// modules/WorldNPC/WorldNPCDialog.js
// NPC对话系统模块

import DebugHelper from '../DebugHelper.js';

export default class WorldNPCDialog {
    constructor(scene, npcManager) {
        this.scene = scene;
        this.npcManager = npcManager;
    }
    
    /**
     * 获取NPC对话
     * @param {string|Object} npc - NPC ID或NPC对象
     * @returns {string|null} NPC对话内容
     */
    getNPCDialog(npc) {
        let targetNPC = null;
        const npcs = this.npcManager.npcs;
        
        // 根据参数类型查找NPC
        if (typeof npc === 'string') {
            targetNPC = npcs.find(n => n.id === npc);
        } else if (npc && npc.sprite) {
            targetNPC = npcs.find(n => n.sprite === npc.sprite);
        } else if (npc && npc.id) {
            targetNPC = npcs.find(n => n.id === npc.id);
        }
        
        if (!targetNPC) {
            DebugHelper.warn('WorldNPCDialog: 未找到指定NPC');
            return null;
        }
        
        const dialog = targetNPC.data.dialog || [];
        if (dialog.length === 0) return null;
        
        // 如果有多条对话，随机返回一条
        if (dialog.length === 1) return dialog[0];
        
        const randomIndex = Math.floor(Math.random() * dialog.length);
        return dialog[randomIndex];
    }
}

